import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { reopenBillingByIdApi } from "../../../services/billing.service";

export default function BillModal({ open, onClose, id, refetch, billStatus }) {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);

  // Reset form when modal is closed
  const handleClose = () => {
    setData("");
    onClose();
  };

  const handleSubmit = async () => {
    if (!data.trim()) {
      toast.error("Please provide a reason for reopening the bill");
      return;
    }
    
    setLoading(true);
    const response = await reopenBillingByIdApi(id, {
      reopenReason: data,
    });
    setLoading(false);

    if (response.code === 200 || response.code === 201) {
      toast.success(`Bill reopened successfully! The bill status has been updated.`);
      handleClose();
      // Refresh the billing data to show updated status
      if (refetch) {
        refetch();
      }
    } else {
      toast.error(response?.message || "Failed to reopen bill. Please try again.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "900px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* dialog title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "20px",
          }}
        >
          <Typography variant="h6" sx={{ color: "#5D6A82" }}>
            Re-open Bill {billStatus ? `(${billStatus})` : ''}
          </Typography>
          <Close
            onClick={handleClose}
            sx={{ cursor: "pointer", color: "#5D6A82" }}
          />
        </Box>

        <Grid
          container
          spacing={3}
          sx={{
            mb: "40px",
          }}
        >
          <Grid item xs={12}>
            <TextField
              multiline
              rows={3}
              label="Reason for Reopening"
              placeholder="Please provide a detailed reason for reopening this bill..."
              value={data}
              onChange={(e) => setData(e.target.value)}
              required
              fullWidth
              sx={{ background: "white", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        {/* submit button */}
        <Box sx={{ my: "20px", textAlign: "center", display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            variant="outlined"
            sx={{ width: "150px", textTransform: "none" }}
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ width: "150px", textTransform: "none" }}
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? <CircularProgress size={24} /> : `Submit`}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
